import { useState } from 'react';

import styles from './styles.module.scss';

import cn from 'classnames';
import eye_close from '../../../../assets/media/icons/eye_close.svg';
import eye from '../../../../assets/media/icons/eye_pass.svg';

import Input from '../../../../components/Basic/Inputs/Base';
import Button from '../../../../components/Basic/Buttons/Button';
import Icon from '../../../../components/Basic/Elements/Icon';

export default function AuthInput({ style, password = false, className, children, ...props }) {
  
  const [showPass, changeShowPass] = useState(false);

  return (
    <Input
      {...props}
      style={{ width: '100%', height: '35px', ...style }}
      type={password && !showPass ? 'password' : 'text'}
      className={cn(styles.auth_input, password && styles.pass_input, className)}
    >
      {password && (
        <Button onClick={() => changeShowPass(!showPass)} className={styles.button_eye}>
          <Icon src={showPass ? eye : eye_close} width={19} height={9} />
        </Button>
      )}
      {children}
    </Input>
  );
}
